import React, {Component} from 'react';
import {inject, observer} from "mobx-react/index";
import axios from "axios/index";

@inject("store")
@observer
export default class ModalShareCalculation extends Component {

    constructor(props) {
        super(props);

        this.state = {
            emailInput: '',
            emailSend: false
        };
    }

    handleChange = (event) => {
        this.setState({emailInput: event.target.value});
    }

    closeModal = () => {
        this.props.closeModal();
    };

    componentWillMount = () => {
        document.body.classList.add("noScroll");
        document.documentElement.classList.add('noScroll');

        $("html, body").animate({scrollTop: 0}, "slow");
    }

    componentWillUnmount = () => {
        document.body.classList.remove('noScroll');
        document.documentElement.classList.remove('noScroll');
    };

    shareSend = () => {

        const {questionCount, result} = this.props.store;
        const {printDate, resultInfo, resultDate, resultDate2, date, date2, ignoreHolidays} = result;
        const questions = result.questions.slice();

        const validateEmail = function (email) {
            var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
            return re.test(email);
        }

        const mail = this.state.emailInput;
        const mailAddresses = mail.split(',');
        let valid = true;
        for (let i = 0; i < mailAddresses.length; i++) {
            const address = mailAddresses[i];
            if (!validateEmail(address.trim())) {
                valid = false;
                break;
            }
        }
        if (valid) {
            const answers = [];
            for (let i = 0; i < questionCount; i++) {
                const q = questions[i];
                const nextQ = (i + 1) < questionCount ? questions[i + 1] : undefined;
                const a = {
                    "question": q.question,
                    "answer": nextQ ? nextQ.answer : printDate
                };
                answers.push(a);
            }

            var data = {
                mail: mail,
                resultInfo: resultInfo,
                date: date,
                resultDate: resultDate,
                date2: date2,
                resultDate2: resultDate2,
                answers: answers,
                ignoreHolidays: ignoreHolidays
            };

            axios.post('/ajax/share', data)
                .then((response) => {

                    this.setState({
                        emailSend: true
                    });

                    setTimeout(() => {
                        this.closeModal();
                    }, 7000);

                })
                .catch((error) => {
                    console.log(error);
                    alert('Det lykkedes ikke at dele resultatet');
                });
        } else {
            alert('Indtast venligst en gyldig e-mail adresse');
        }
    };

    render() {

        const emailSend = this.state.emailSend;

        return (
            <div className="share-popup">
                <div className="inner">
                    <span className="close" onClick={this.closeModal}></span>
                    <div className="wrap">
                        <h2>Del resultat</h2>
                        <p>Skriv inn en e-post adresse som resultatet av din beregning skal sendes til. Du kan sende til flere adresses ved å skrive inn hver enkelt adressene adskilt med et komma. Vi bruker de oppgitte opplysningene kun til å sende resultatet og sletter dem deretter.&quot;</p>
                        {!emailSend &&
                        <p id="share-input">
                            <input id="share-mail" type='email' name='mail' placeholder="E-mail"
                                   onChange={this.handleChange}/>
                            <button id="share-send" onClick={this.shareSend}>Send</button>
                        </p>
                        }
                        {emailSend &&
                        <p id="share-result">
                            <label className="share-complete">Ditt resultat er nå sendt.</label>
                        </p>
                        }

                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ModalShareCalculation.js